<template>
  <div class="ts-app-shell_fh">
    <CheckListTemplate :currentPage="currentPageStep">
      <div class="check-list-form">
        <div class="content-type">
          <span class="numeral-item">4.</span>
          <span>Adult Service Priority</span>
        </div>
        <p>Please enter your information regarding your eligibility in WIOA.</p>
        <el-form @submit.native.prevent="updateCheckList">
          <div class="content-type">
            <p class="heavy-text">
              Temporary Assistance for Needy Families (TANF)
            </p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a recipient of Temporary Assistance for Needy Families
                  (TANF)?
                </label>
                <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.AdultServicePriority.TANF.IsRecipientOfTANF')">
                  <el-radio-group v-model="adultServicePriority.tanf.isRecipientOfTANF" class="ml-4">
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">
              Supplemental Nutrition Assistance Program (SNAP)
            </p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a recipient of Supplemental Assistance Program?
                </label>
                <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.AdultServicePriority.SNAP.IsRecipientOfSNAP')">
                  <el-radio-group v-model="adultServicePriority.snap.isRecipientOfSNAP" class="ml-4">
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">
              Supplemental Security Income (SSI)/Social Security Disability
              Insurance (SSDI)
            </p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a recipient of Supplemental Security Income
                  (SSI)/Social Security Disability Insurance (SSDI)
                </label>
                <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.AdultServicePriority.SSDI.IsRecipientOfSSDI')">
                  <el-radio-group v-model="adultServicePriority.ssdi.isRecipientOfSSDI" class="ml-4">
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">State or Local General Assistance (GA)</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a recipient of State or Local General Assistance (GA)?
                </label>
                <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.AdultServicePriority.GA.IsRecipientOfGA')">
                  <el-radio-group v-model="adultServicePriority.ga.isRecipientOfGA" class="ml-4">
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>
          <div class="content-type">
            <p class="heavy-text">Refugee Cash Assistance (RCA)</p>
          </div>
          <div class="content-item">
            <el-row>
              <div class="mb-2 flex items-center text-sm">
                <label role="text">
                  Are you a recipient of State or Local General Assistance (GA)?
                </label>
                <el-form-item :error="retrieveFieldError(modelState, 'WioaChecklistRequest.AdultServicePriority.RCA.IsRecipientOfRCA')">
                  <el-radio-group v-model="adultServicePriority.rca.isRecipientOfRCA" class="ml-4">
                    <el-radio :label="true" size="large">Yes</el-radio>
                    <el-radio :label="false" size="large">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-row>
          </div>

          <div class="content-item action-section">
            <el-row>
              <el-col :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-outline wioa-btn-outline"
                  @click="backToDashboard"
                >
                  Previous
                </el-button>
              </el-col>
              <el-col :offset="2" :xs="4" :md="4" :lg="4">
                <el-button
                  class="ts-btn ts-btn-secondary"
                  @click="updateCheckList"
                >
                  Continue
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </CheckListTemplate>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import CheckListTemplate from "../../component/checkListTemplate.vue";
import TSLoading from "../../../../components/TSLoading.vue";

export default {
  components: { CheckListTemplate, TSLoading },
  data(){
    return  {
      modelState: {},
      loading: false,
      adultServicePriority: { 
        tanf: {
          isRecipientOfTANF: null
        },
        snap: {
          isRecipientOfSNAP: null
        },
        ssdi: {
          isRecipientOfSSDI: null
        },
        ga: {
          isRecipientOfGA: null
        },
        rca: {
          isRecipientOfRCA: null
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.match("wioa/complete-checklist/") == null) {
      this.$confirm(
        "Are you sure you want to leave this page?",
        "Warning!",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          type: "warning",
          center: true,
        }).then(() => {
          this.$message.success("Your checklist are saved as draft!");
          localStorage.removeItem('editChecklist');
          next();
        })
        .catch(() => false);
    } else {
      next();
    }
  },
  created(){
    debugger;
    window.scrollTo(0,0);
    if(this.editChecklistId){
      this.loading = true;
      this.$store.dispatch("wioa/getChecklistToReview", this.editChecklistId).then((res) => {
        debugger;
        // this.adultServicePriority = res.checklist.adultServicePriority;
        if(res.checklist.adultServicePriority.tanf) this.adultServicePriority.tanf = res.checklist.adultServicePriority.tanf;
        if(res.checklist.adultServicePriority.snap) this.adultServicePriority.snap = res.checklist.adultServicePriority.snap;
        if(res.checklist.adultServicePriority.ssdi) this.adultServicePriority.ssdi = res.checklist.adultServicePriority.ssdi;
        if(res.checklist.adultServicePriority.ga) this.adultServicePriority.ga = res.checklist.adultServicePriority.ga;
        if(res.checklist.adultServicePriority.rca) this.adultServicePriority.rca = res.checklist.adultServicePriority.rca;
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },
  methods: {
    getChecklistId(){
      return this.$route.params.checklistId;
    },
    backToDashboard() {
      this.$router.push({ name: "WioaChecklistThree", params: { checklistId: this.getChecklistId() } });
    },
    updateCheckList() {
      this.loading = true;
      let checklist = {
        "type": 2.2,
        "checklist": {
          "id": (this.editChecklistId == null) ? this.getChecklistId() : this.editChecklistId,
          "adultServicePriority": this.adultServicePriority
        }
      }
      this.$store.dispatch("wioa/completeCheckList", checklist).then((res) => {
        debugger;
        if(res){
          this.$router.push({ name: "WioaChecklistFive", params: { checklistId: this.getChecklistId() } });
        }
      }).catch((res) => {
        debugger;
        this.modelState  = res;
      })
      .finally(() => {
        this.loading = false;
      });
      
    },
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
    editChecklistId() {
      return localStorage.getItem('editChecklist');
    },
  },
};
</script>
